import { z } from "zod";

import { machineSchema } from "./machine";

const machineAlarmSchema = z.object({
	message: z.string(),
	code: z.number().optional(),
	argument: z.number().optional(),
});

const machineStopReasonSchema = z.object({
	id: z.string().optional(),
	rootCauseId: z.string().optional(),
	isActive: z.boolean(),
	message: z.string().optional(),
});

const physicalMachineSettingsSchema = z.object({}).passthrough();

export const lantechMachineSchema = machineSchema.omit({ warnings: true, activeStopReason: true }).extend({
	warnings: z.array(machineAlarmSchema).optional(),
	activeStopReason: machineStopReasonSchema.optional(),
	physicalMachineSettings: physicalMachineSettingsSchema.nullish(),
});

export type LantechMachine = z.infer<typeof lantechMachineSchema>;
